import * as yup from 'yup'

export class NeedsClusterReinstalledClusterWithOdometerPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    clusterReinstallClusterWithOdometerPhotoFile?: File = undefined
  alsoUseForOdometerAfterModificationPhoto?: boolean = undefined
  clusterReinstallClusterWithOdometerIsTachometerPresent?: boolean = undefined
  clusterReinstallClusterWithOdometerIsOilPressureGaugePresent?: boolean = undefined
  clusterReinstallClusterWithOdometerIsTPMSPresent?: boolean = undefined
}

export const NeedsClusterReinstalledClusterWithOdometerPhotoDtoSchema = yup.object({
    clusterReinstallClusterWithOdometerPhotoFile: yup
    .mixed()
    // @ts-ignore
    .test('Cluster With Odometer Photo is Required..', 'File ', (value: File) => value)
    .required('Cluster With Odometer Photo is Required.'),
  alsoUseForOdometerAfterModificationPhoto: yup.boolean().notRequired(),
  clusterReinstallClusterWithOdometerIsTachometerPresent: yup.boolean().nullable(),
  clusterReinstallClusterWithOdometerIsOilPressureGaugePresent: yup.boolean().nullable(),
  clusterReinstallClusterWithOdometerIsTPMSPresent: yup.boolean().nullable()
})
